import React from 'react';
import PropTypes from 'prop-types';

import { getPreorderData } from '../../Utils/VariantUtils';
import { getOutOfStockSpan } from '../../Utils/ProductUtils';

import { StyledPdpMessage } from './ProductMessagingStyles';

var _ref2 = React.createElement(
  StyledPdpMessage,
  null,
  'This item is not eligible for discounts.'
);

var _ref3 = React.createElement(
  StyledPdpMessage,
  null,
  'Coming Soon'
);

var _ref4 = React.createElement(
  StyledPdpMessage,
  null,
  'Non-Returnable.'
);

var ProductMessaging = function ProductMessaging(_ref) {
  var product = _ref.product,
      selectedVariant = _ref.selectedVariant,
      lowStockThreshold = _ref.lowStockThreshold,
      selectedVariantInventory = _ref.selectedVariantInventory;

  // Out of Stock Span
  var preorderData = getPreorderData(selectedVariant.preorderDate);
  var productPreOrderData = getPreorderData(product.preorderDate);
  var lowInStockThreshold = parseInt(lowStockThreshold) || 8;
  var outOfStock = !selectedVariant.availableForSale;

  var nonReturnable = product.tags.includes('NONRETURNABLE');

  // Ineligible for discount
  var ineligibleForDiscount = product.tags.includes('data--no_coupon:1');
  var outOfStockSpan = getOutOfStockSpan(preorderData, productPreOrderData, selectedVariantInventory, lowInStockThreshold, outOfStock);

  // Coming Soon
  var comingSoon = product.tags.includes('data--comingsoon');

  return React.createElement(
    'div',
    null,
    outOfStockSpan && React.createElement(
      StyledPdpMessage,
      null,
      outOfStockSpan
    ),
    ineligibleForDiscount && _ref2,
    comingSoon && _ref3,
    nonReturnable && _ref4
  );
};

ProductMessaging.propTypes = {
  product: PropTypes.object,
  selectedVariant: PropTypes.object,
  lowStockThreshold: PropTypes.string,
  selectedVariantInventory: PropTypes.number
};

export default ProductMessaging;